import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Paginate } from 'src/app/models/interfaces/paginate';
import { ApiEntryControlService } from 'src/app/modules/entry-control/api-entry-control.service';
import { Devices } from 'src/app/modules/entry-control/interfaces/devices';
import { Facility } from 'src/app/modules/entry-control/interfaces/facility';

@Component({
  selector: 'app-list-phones',
  templateUrl: './list-phones.component.html',
  styleUrls: ['./list-phones.component.css']
})
export class ListPhonesComponent implements OnInit {
  error: any;
  constructor(
    private api: ApiEntryControlService,
    private modal: NgbModal,
    private toast: ToastrService,
    private router: Router,

  ) { }
  view: number = 1;
  status: any;
  categorys: any;
  idSelected: number = 0;
  facilityes: Facility[];
  ngOnInit(): void {
    this.get();
    this.api.getAllFacility().subscribe(
      (response) => {
        this.facilityes = response.data as Facility[];
      }
    );
  }

  items: any[];
  page = 1;
  perpage: number = 0;
  collectionSize = 0;
  totalPage = 0;

  brands: any;
  form = new UntypedFormGroup({
    id: new UntypedFormControl(),
    facility_id:new UntypedFormControl(0),
    // guard = teléfonos de guardias; supervisor = teléfonos de supervisores asignados a un perfil
    kind: new UntypedFormControl('guard'),
  });

  get isSupervisor(): boolean {
    return this.form.get('kind')?.value === 'supervisor';
  }

  // ---- vincular un teléfono de supervisor a un perfil
  profiles: any[] = [];
  knownPhones: any[] = [];
  link = { device_id: '', device_name: '', profile_id: 0 };
  linkError = '';

  openLink(md: any, item?: any) {
    this.link = { device_id: item?.identification ?? '', device_name: item?.name ?? '', profile_id: item?.profile_id ?? 0 };
    this.linkError = '';
    this.api.supervisorProfiles().subscribe((r) => (this.profiles = (r.data as any[]) ?? []));
    this.api.supervisorKnownPhones().subscribe((r) => (this.knownPhones = (r.data as any[]) ?? []));
    this.modal.open(md, { size: 'md' });
  }

  pickKnown(deviceId: string) {
    const k = this.knownPhones.find((p) => p.device_id === deviceId);
    this.link.device_id = deviceId;
    if (k) {
      this.link.device_name = k.name ?? '';
      if (k.profile_id) this.link.profile_id = k.profile_id;
    }
  }

  saveLink() {
    if (!this.link.device_id.trim() || !this.link.profile_id) {
      this.linkError = 'Indique el teléfono y elija un perfil';
      return;
    }
    this.api.assignSupervisorPhone(this.link.device_id.trim(), Number(this.link.profile_id), this.link.device_name.trim()).subscribe(
      (res) => {
        this.toast.success(res.msg, 'Gestión dispositivos');
        this.modal.dismissAll();
        this.get();
      },
      (e) => {
        this.linkError = (e.error?.mistakes?.join?.(', ') || e.error?.msg || 'No fue posible vincular el teléfono');
      }
    );
  }

  changeKind() {
    this.page = 1;
    this.items = [];
    this.get();
  }
  delete() {
    const request = this.isSupervisor ? this.api.unassignSupervisorPhone(this.form.get('id')?.value) : this.api.deleteDevices(this.form);
    request.subscribe(
      (res) => {
        this.toast.success(
          res.msg,
          'Gestión dispositivos'
        );
        this.modal.dismissAll();
        this.get();
      },
      (e) => {
        this.toast.warning(e.error.mistakes, e.error.msg);
      }
    );
  }

  get() {
    this.api.paginateDevices(this.page,this.form).subscribe(
      (response) => {
        var data = response.data as Paginate;
        this.items = data.items as Devices[];
        this.page = data.current;
        this.perpage = data.per_page;
        this.collectionSize = data.count;
        console.log(this.collectionSize);
        this.totalPage = data.total;
      },
      (e) => {
        this.items = []
        this.page = 1;
      }
    );
  }
  openModal(md: any, size: string = 'md') {
    this.modal.open(md, {
      size: size,
    });
  }
  openEdit(id: number, md: any) {
    this.idSelected = id;
    this.modal.open(md, {
      size: 'md',
    });
  }
  openDelete(id: number, md: any) {
    this.form.get('id').setValue(id);
    this.modal.open(md, {
      size: 'md',
    });
  }
  search() {
    this.get();
  }
  clean() { }
}

